module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<div class=\"main\">\n\t<gw-nav></gw-nav>\n  \t<router-outlet></router-outlet>\n  \t<gw-footer></gw-footer>\n</div>\n \n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 3